import { Bar } from "react-chartjs-2";
import React from "react";

const DynamicChart = React.memo(({ max, data }) => {
  const options = {
    scales: {
      y: {
        suggestedMin: 0,
        suggestedMax: max,
      },
    },
  };
  return (
    <>
      <Bar data={data} options={options} redraw={true} />
    </>
  );
});

export default DynamicChart;
